import { $, $$ } from "../utils/dom";

const navigationOpenButton = $("[data-js='navigation-trigger']");
const navigationNav = $("[data-js='navigation-target']");
const navigationItems = $$("a", navigationNav);

const isMobileNav = () => {
  return window.innerWidth < breakpoint ? true : false;
};

const setAttributes = () => {
  navigationItems.forEach((item) => {
    item.setAttribute("tabindex", "-1");
  });
};

const handleNavigation = () => {
  navigationNav.classList.toggle("navigation--open");
  navigationOpenButton.classList.toggle("is-open");

  if (navigationOpenButton.getAttribute("aria-expanded") === "false") {
    navigationOpenButton.setAttribute("aria-expanded", "true");
  } else {
    navigationOpenButton.setAttribute("aria-expanded", "false");
  }

  navigationItems.forEach((item) => {
    if (item.getAttribute("tabindex") === "-1") {
      item.setAttribute("tabindex", "0");
    } else {
      item.setAttribute("tabindex", "-1");
    }
  });
};

const init = () => {
  setAttributes();

  navigationOpenButton.addEventListener("click", () => {
    handleNavigation();
  });
};

if (navigationOpenButton) {
  init();
}
